module.exports = __webpack_public_path__ + "03dba545f573596fe2dbeee2e970ba00.svg";